"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.common.help': 'Gli avatar comuni sono visibili a tutti gli utenti ma non possono essere modificati da non super-amministratori',
};
